import { render, staticRenderFns } from "./MDomainsDetail.vue?vue&type=template&id=335bfd8b&"
import script from "./MDomainsDetail.vue?vue&type=script&lang=ts&"
export * from "./MDomainsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports